import React, { useEffect, useState } from 'react'
import { GlobalTable, HeaderLine, Td, Th, Tr } from '../../../../components/styles/table-style'
import { useOutletContext } from 'react-router-dom'
import { FashionOutletType } from '..'
import dots from '../../../../assets/fashion/TableFashionHeader/dots.svg'
import Actions from '../FashionActions'
import { ActionContainer } from './style'

type CompanyType = {
  id: number;
  companyName: string; // Alterado para companyName
}

type OrderType = {
  id: number
  companyId: number
  createdAt: string
  startDateOfDelivery: string
  quantityItems: string
  quantityPieces: string
  status: string
  totalCost: number
  saleStatus: string
}

const FashionOrdersTable: React.FC = () => {
  const { setTabIndex } = useOutletContext<FashionOutletType>()
  const [openActionId, setOpenActionId] = useState<number | null>(null)
  const [orders, setOrders] = useState<OrderType[]>([]) // estado para os pedidos
  const [companies, setCompanies] = useState<CompanyType[]>([]) // estado para as empresas

  const columns = ["Nº do pedido", "Cliente", "Data pedido", "Data entrega", "Qtd. de itens", "Qtd. de peças", "Status", "Total (R$)", "Venda", ""]

  // Função para buscar as empresas
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetch('https://companies-260311756054.southamerica-east1.run.app/companies?filters[0]=1')
        const data = await response.json()
        console.log("Empresas recebidas:", data); // Verifique a estrutura dos dados
        setCompanies(Array.isArray(data) ? data : []) // Garantir que seja um array
      } catch (error) {
        console.error('Erro ao buscar as empresas:', error)
      }
    }

    fetchCompanies()
  }, [])

  // Função para buscar o nome da empresa com base no companyId
  const getCompanyName = (companyId: number) => {
    const company = companies.find(c => c.id === companyId)
    return company ? company.companyName : 'N/A' // Acessando o companyName
  }

  // Função para buscar os pedidos
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FASHION_ORDERS_BASE_URL}/fashion-order/fashion-orders`)
        const data = await response.json()
        setOrders(data)
      } catch (error) {
        console.error('Erro ao buscar os pedidos:', error)
      }
    }

    fetchOrders()
  }, [])

  return (
    <GlobalTable>
      <thead>
        <HeaderLine>
          {columns.map((item, index) => (
            <Th key={index}>{item}</Th>
          ))}
        </HeaderLine>
      </thead>
      <tbody>
        {orders.map((order) => (
          <Tr key={order.id}>
            <Td>{order.id}</Td>
            <Td>{getCompanyName(order.companyId)}</Td> {/* Exibindo o nome da empresa */}
            <Td>{new Date(order.createdAt).toLocaleDateString('pt-BR')}</Td>
            <Td>{new Date(order.startDateOfDelivery).toLocaleDateString('pt-BR')}</Td>
            <Td>{order.quantityItems}</Td>
            <Td>{order.quantityPieces}</Td>
            <Td>{order.status}</Td>
            <Td>R${order.totalCost?.toFixed(2) ?? '0,00'}</Td>
            <Td>{order.saleStatus}</Td>
            <Td>
              <img
                onClick={() => setOpenActionId(openActionId === order.id ? null : order.id)}
                src={dots}
                alt="Opções"
                className="w-4 h-4 cursor-pointer"
              />
              {openActionId === order.id && (
                <ActionContainer>
                  <Actions 
                    orderId={order.id}
                    onDelete={() => setOrders((prev: OrderType[]) => prev.filter((o) => o.id !== order.id))}
                  />
                </ActionContainer>
              )}
            </Td>
          </Tr>
        ))}
      </tbody>
    </GlobalTable>
  )
}

export default FashionOrdersTable
